
export const getTimeStringForView = (unixtime) => {
  const locale = 'ja-JP'
  let convTime = 0;

  if(typeof unixtime == 'string' ){
    convTime = Number(unixtime);
  }else{
    convTime = unixtime
  }
  const dateTime = new Date(convTime*1000);

  return dateTime.toLocaleDateString() + " " + dateTime.toLocaleTimeString(locale);
};